<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<div class="propertylist_table">
	<p-table class="propertyTable" #pt [value]="properties" [paginator]="true" [rows]="250" [rowsPerPageOptions]="[250,500,1000]" [lazy]="true"
		(onLazyLoad)="loadLazy($event)" [totalRecords]="recordTotal" [responsive]="true" sortMode="multiple" [columns]="columns"
		
		selectionMode="single" [(selection)]="property" dataKey="shortTermRentalId" (onRowSelect)="onRowSelect($event)"
		showCurrentPageReport="true" currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
		[loading]="loading" styleClass="property-list-table p-datatable-striped" [ngStyle]="{'width': 'auto'}">
		<ng-template pTemplate="caption">
		<div class="d-flex text-end justify-content-end align-items-center">
				<span>
					<!--clear filters-->
					<button pButton pRipple class="p-button-text"
						style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px; margin-top: 0px !important;"
						(click)="reloadPage()">Clear Filters</button>
	
					<!--add new-->
				<button pButton pRipple class="p-button" routerLink="/property-add" style="padding: 0.643rem 0.75rem !important; margin-top: 0px !important;">New Property +</button>
	
					<app-import-export importEnabled="false" [dataRetrived]="properties" (exportDataSelected)="exportSelected($event)" [columns]="columns" [importDisabled]="true"></app-import-export>
				</span>
			</div>
		</ng-template>
		<ng-template pTemplate="header">
			<tr class="propertylist-table-head property-sticky-column">
				<th [pSortableColumn]="'shortTermRentalId'" 
				pFrozenColumn>
					<p-sortIcon [field]="'shortTermRentalId'"></p-sortIcon>Id
				</th>
				<th [pSortableColumn]="'listingStatus'" 
				pFrozenColumn>
					<p-sortIcon [field]="'listingStatus'"></p-sortIcon>Status
				</th>
				<th [pSortableColumn]="'propertyCode'" 
				pFrozenColumn>
					<p-sortIcon [field]="'propertyCode'"></p-sortIcon>Property
				</th>
				<th [pSortableColumn]="'listingType'">
					<p-sortIcon [field]="'listingType'"></p-sortIcon>Listing Type
				</th>
				<th [pSortableColumn]="'locationId'">
					<p-sortIcon [field]="'locationId'"></p-sortIcon>Location
				</th>
				<th [pSortableColumn]="'propertyName'">
					<p-sortIcon [field]="'propertyName'"></p-sortIcon>Property Name
				</th>
				<th [pSortableColumn]="'developmentVO.addressDevelopmentName'">
					<p-sortIcon [field]="'developmentVO.addressDevelopmentName'"></p-sortIcon>Development
				</th>
				<th [pSortableColumn]="'addressType'">
					<p-sortIcon [field]="'addressType'"></p-sortIcon>Adr Type
				</th>
				<th [pSortableColumn]="'addressStreetNumber'">
					<p-sortIcon [field]="'addressStreetNumber'"></p-sortIcon>Adr Street Num
				</th>
				<th [pSortableColumn]="'addressStreetName'">
					<p-sortIcon [field]="'addressStreetName'"></p-sortIcon>Adr Street Name
				</th>
				<th [pSortableColumn]="'addressUnit'">
					<p-sortIcon [field]="'addressUnit'"></p-sortIcon>Unit
				</th>
				<th [pSortableColumn]="'address2'">
					<p-sortIcon [field]="'address2'"></p-sortIcon>Address2
				</th>
				<th [pSortableColumn]="'addressBuildingName'">
					<p-sortIcon [field]="'addressBuildingName'"></p-sortIcon>Building Name
				</th>
				<th [pSortableColumn]="'addressComplexName'">
					<p-sortIcon [field]="'addressComplexName'"></p-sortIcon>Complex Name
				</th>
				<th [pSortableColumn]="'addressDistrictName'">
					<p-sortIcon [field]="'addressDistrictName'"></p-sortIcon>District
				</th>
				<th [pSortableColumn]="'addressCity'">
					<p-sortIcon [field]="'addressCity'"></p-sortIcon>City
				</th>
				<th [pSortableColumn]="'addressCounty'">
					<p-sortIcon [field]="'addressCounty'"></p-sortIcon>County
				</th>
				<th [pSortableColumn]="'addressMetro'">
					<p-sortIcon [field]="'addressMetro'"></p-sortIcon>Metro
				</th>
				<th [pSortableColumn]="'addressCountry'">
					<p-sortIcon [field]="'addressCountry'"></p-sortIcon>Country
				</th>
				<th [pSortableColumn]="'addressRegion'">
					<p-sortIcon [field]="'addressRegion'"></p-sortIcon>Region
				</th>
				<th [pSortableColumn]="'addressState'">
					<p-sortIcon [field]="'addressState'"></p-sortIcon>State
				</th>
				<th [pSortableColumn]="'addressZip'">
					<p-sortIcon [field]="'addressZip'"></p-sortIcon>Zip
				</th>
				<th [pSortableColumn]="'addressIsland'">
					<p-sortIcon [field]="'addressIsland'"></p-sortIcon>Island
				</th>
				<th [pSortableColumn]="'crossStreet'">
					<p-sortIcon [field]="'crossStreet'"></p-sortIcon>Cross Street
				</th>
				<th [pSortableColumn]="'longitude'">
					<p-sortIcon [field]="'longitude'"></p-sortIcon>Longitude
				</th>
				<th [pSortableColumn]="'latitude'">
					<p-sortIcon [field]="'latitude'"></p-sortIcon>Latitude
				</th>
				<th [pSortableColumn]="'propertyType'">
					<p-sortIcon [field]="'propertyType'"></p-sortIcon>Property Type
				</th>
				<th [pSortableColumn]="'propertySubType'">
					<p-sortIcon [field]="'propertySubType'"></p-sortIcon>Property SubType
				</th>
				<th [pSortableColumn]="'yearBuilt'">
					<p-sortIcon [field]="'yearBuilt'"></p-sortIcon>Year Built
				</th>
				<th [pSortableColumn]="'floorOfProperty'">
					<p-sortIcon [field]="'floorOfProperty'"></p-sortIcon>FloorOfProperty
				</th>
				<th [pSortableColumn]="'floorsInBuilding'">
					<p-sortIcon [field]="'floorsInBuilding'"></p-sortIcon>FloorsInBuilding
				</th>
				<th [pSortableColumn]="'squareFootageInterior'">
					<p-sortIcon [field]="'squareFootageInterior'"></p-sortIcon>SquareFootageInterior
				</th>
				<th [pSortableColumn]="'squareFootageExterior'">
					<p-sortIcon [field]="'squareFootageExterior'"></p-sortIcon>SquareFootageExterior
				</th>
				<th [pSortableColumn]="'squareFootageLot'">
					<p-sortIcon [field]="'squareFootageLot'"></p-sortIcon>SquareFootageLot
				</th>
				
				<th [pSortableColumn]="'bedrooms'">
					<p-sortIcon [field]="'bedrooms'"></p-sortIcon>Beds
				</th>
				<th [pSortableColumn]="'sleepsMax'">
					<p-sortIcon [field]="'sleepsMax'"></p-sortIcon>SleepsMax
				</th>
				<th [pSortableColumn]="'sleepsMaxInBeds'">
					<p-sortIcon [field]="'sleepsMaxInBeds'"></p-sortIcon>SleepsMaxInBeds
				</th>
				<th [pSortableColumn]="'bathrooms'">
					<p-sortIcon [field]="'bathrooms'"></p-sortIcon>Baths
				</th>
				
				<th [pSortableColumn]="'hotelRoomType'">
					<p-sortIcon [field]="'hotelRoomType'"></p-sortIcon>HotelRoomType
				</th>
				<th [pSortableColumn]="'showBookOnline'">
					<p-sortIcon [field]="'showBookOnline'"></p-sortIcon>ShowBookOnline
				</th>
				<th [pSortableColumn]="'showPublicCalendar'">
					<p-sortIcon [field]="'showPublicCalendar'"></p-sortIcon>Show Public Calendar
				</th>
	
				<th [pSortableColumn]="'minNightlyRate'">
					<p-sortIcon [field]="'minNightlyRate'"></p-sortIcon>MinNightlyRate
				</th>
				<th [pSortableColumn]="'annualRevTargetAmnt'">
					<p-sortIcon [field]="'annualRevTargetAmnt'"></p-sortIcon>AnnualRevTargetAmnt
				</th>
				<th [pSortableColumn]="'rateBucketAdjusterPct'">
					<p-sortIcon [field]="'rateBucketAdjusterPct'"></p-sortIcon>RateBucketAdjusterPct
				</th>
				<th [pSortableColumn]="'guestFeeNightly'">
					<p-sortIcon [field]="'guestFeeNightly'"></p-sortIcon>GuestFeeNightly
				</th>
				<th [pSortableColumn]="'minLengthOfStay'">
					<p-sortIcon [field]="'minLengthOfStay'"></p-sortIcon>MinLengthOfStay
				</th>
				<th [pSortableColumn]="'cleaningFeeDepartureStandard'">
					<p-sortIcon [field]="'cleaningFeeDepartureStandard'"></p-sortIcon>CleaningFeeDepartureStandard
				</th>
				<th [pSortableColumn]="'cleaningFeeInterimStandard'">
					<p-sortIcon [field]="'cleaningFeeInterimStandard'"></p-sortIcon>CleaningFeeInterimStandard
				</th>
	
				<th [pSortableColumn]="'salesTaxRate'">
					<p-sortIcon [field]="'salesTaxRate'"></p-sortIcon>SalesTaxRate
				</th>
				<th [pSortableColumn]="'roomTaxRate'">
					<p-sortIcon [field]="'roomTaxRate'"></p-sortIcon>RoomTaxRate
				</th>
				
				<th [pSortableColumn]="'rULocationId'">
					<p-sortIcon [field]="'rULocationId'"></p-sortIcon>RULocationId
				</th>
	
				<th [pSortableColumn]="'rentalTaxIdNumber'">
					<p-sortIcon [field]="'rentalTaxIdNumber'"></p-sortIcon>TAT
				</th>
				<th [pSortableColumn]="'rentalPermitIdNumber'">
					<p-sortIcon [field]="'rentalPermitIdNumber'"></p-sortIcon>RentalPermitIdNumber
				</th>
				<th [pSortableColumn]="'vrboListingNumber'">
					<p-sortIcon [field]="'vrboListingNumber'"></p-sortIcon>VRBO
				</th>
				<th [pSortableColumn]="'ruPropertyId'">
					<p-sortIcon [field]="'ruPropertyId'"></p-sortIcon>RU
				</th>
				<th [pSortableColumn]="'slPropertyId'">
					<p-sortIcon [field]="'slPropertyId'"></p-sortIcon>SL PropertyId
				</th>
				<th [pSortableColumn]="'matterportListingNumber'">
					<p-sortIcon [field]="'matterportListingNumber'"></p-sortIcon>Matterport
				</th>
				<th [pSortableColumn]="'sitePriority'">
					<p-sortIcon [field]="'sitePriority'"></p-sortIcon>Site Priority
				</th>
				
				<th> Action
				</th>
			</tr>
	
			<tr class="property-sticky-column">
				<th [ngStyle]="{'width': 'auto'}" 
				pFrozenColumn><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:100px;" type="number" (input)="pt.filter($event.target.value, 'shortTermRentalId', 'in')"></th>
				<th 
				pFrozenColumn>
					<p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="listingStatuses" appendTo="body"
						(onChange)="pt.filter($event.value, 'listingStatus', 'in')" styleClass="p-column-filter"
						placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
						<ng-template let-option pTemplate="item">
							<span>{{option.name}}</span>
						</ng-template>
					</p-dropdown>
				</th>
				<th [ngStyle]="{'width': 'auto'}" 
				pFrozenColumn><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
					style="width:100px;" type="text" (input)="pt.filter($event.target.value, 'propertyCode', 'in')"
					[value]="pt.filters['propertyCode'] ? pt.filters['propertyCode'].value : ''"></th>
				<th>
					<p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="propertyTypes" appendTo="body"
						(onChange)="pt.filter($event.value, 'listingType', 'in')" styleClass="p-column-filter" placeholder="Filter"
						[showClear]="true" optionLabel="name" optionValue="value">
						<ng-template let-option pTemplate="item">
							<span>{{option.name}}</span>
						</ng-template>
					</p-dropdown>
				</th>
				<th>
					<p-dropdown [style]="{'width':'50px','min-width':'100%'}" [options]="locations" appendTo="body"
						(onChange)="pt.filter($event.value, 'locationId', 'in')" styleClass="p-column-filter" placeholder="Filter"
						[showClear]="true" optionLabel="name" optionValue="locationId"
						[value]="pt.filters['locationId'] ? pt.filters['locationId'].value : ''">
						<ng-template let-option pTemplate="item">
							<span>{{option.name}}</span>
						</ng-template>
					</p-dropdown>
				</th>
				
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:100px;" type="text" (input)="pt.filter($event.target.value, 'propertyName', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:100px;" type="text"
						(input)="pt.filter($event.target.value, 'developmentVO.addressDevelopmentName', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:100px;" type="text" (input)="pt.filter($event.target.value, 'addressType', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:100px;" type="text" (input)="pt.filter($event.target.value, 'addressStreetNumber', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:100px;" type="text" (input)="pt.filter($event.target.value, 'addressStreetName', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:100px;" type="text" (input)="pt.filter($event.target.value, 'addressUnit', 'in')"></th>
			
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:100px;" type="text" (input)="pt.filter($event.target.value, 'address2', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:100px;" type="text" (input)="pt.filter($event.target.value, 'addressBuildingName', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:100px;" type="text" (input)="pt.filter($event.target.value, 'addressComplexName', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:100px;" type="text" (input)="pt.filter($event.target.value, 'addressDistrictName', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:100px;" type="text" (input)="pt.filter($event.target.value, 'addressCity', 'in')"></th>
			
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:100px;" type="text" (input)="pt.filter($event.target.value, 'addressCounty', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:100px;" type="text" (input)="pt.filter($event.target.value, 'addressMetro', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:100px;" type="text" (input)="pt.filter($event.target.value, 'addressCountry', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:100px;" type="text" (input)="pt.filter($event.target.value, 'addressRegion', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:100px;" type="text" (input)="pt.filter($event.target.value, 'addressState', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:100px;" type="text" (input)="pt.filter($event.target.value, 'addressZip', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:100px;" type="text" (input)="pt.filter($event.target.value, 'addressIsland', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:100px;" type="text" (input)="pt.filter($event.target.value, 'crossStreet', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:100px;" type="text" (input)="pt.filter($event.target.value, 'longitude', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:100px;" type="text" (input)="pt.filter($event.target.value, 'latitude', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:100px;" type="text" (input)="pt.filter($event.target.value, 'propertyType', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:100px;" type="text" (input)="pt.filter($event.target.value, 'propertySubType', 'in')"></th>
			
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:100px;" type="text" (input)="pt.filter($event.target.value, 'yearBuilt', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:100px;" type="text" (input)="pt.filter($event.target.value, 'floorOfProperty', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:100px;" type="text" (input)="pt.filter($event.target.value, 'floorsInBuilding', 'in')"></th>
			
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:100px;" type="text" (input)="pt.filter($event.target.value, 'squareFootageInterior', 'in')">
				</th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:100px;" type="text" (input)="pt.filter($event.target.value, 'squareFootageExterior', 'in')">
				</th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:100px;" type="text" (input)="pt.filter($event.target.value, 'squareFootageLot', 'in')"></th>
			
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:50px;" type="text" (input)="pt.filter($event.target.value, 'bedrooms', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:50px;" type="text" (input)="pt.filter($event.target.value, 'sleepsMax', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:50px;" type="text" (input)="pt.filter($event.target.value, 'sleepsMaxInBeds', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:50px;" type="text" (input)="pt.filter($event.target.value, 'bathrooms', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:50px;" type="text" (input)="pt.filter($event.target.value, 'hotelRoomType', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:50px;" type="text" (input)="pt.filter($event.target.value, 'showBookOnline', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:50px;" type="text" (input)="pt.filter($event.target.value, 'showPublicCalendar', 'in')"></th>
			
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:50px;" type="text" (input)="pt.filter($event.target.value, 'minNightlyRate', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:50px;" type="text" (input)="pt.filter($event.target.value, 'annualRevTargetAmnt', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:50px;" type="text" (input)="pt.filter($event.target.value, 'rateBucketAdjusterPct', 'in')">
				</th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:50px;" type="text" (input)="pt.filter($event.target.value, 'guestFeeNightly', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:50px;" type="text" (input)="pt.filter($event.target.value, 'minLengthOfStay', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:50px;" type="text"
						(input)="pt.filter($event.target.value, 'cleaningFeeDepartureStandard', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:50px;" type="text"
						(input)="pt.filter($event.target.value, 'cleaningFeeInterimStandard', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:50px;" type="text" (input)="pt.filter($event.target.value, 'salesTaxRate', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:50px;" type="text" (input)="pt.filter($event.target.value, 'roomTaxRate', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:50px;" type="text" (input)="pt.filter($event.target.value, 'rULocationId', 'in')"></th>
			
			
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:50px;" type="text" (input)="pt.filter($event.target.value, 'rentalTaxIdNumber', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:50px;" type="text" (input)="pt.filter($event.target.value, 'rentalPermitIdNumber', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:50px;" type="text" (input)="pt.filter($event.target.value, 'vrboListingNumber', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:50px;" type="text" (input)="pt.filter($event.target.value, 'ruPropertyId', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:50px;" type="text" (input)="pt.filter($event.target.value, 'slPropertyId', 'in')"></th>
				<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
						style="width:50px;" type="text" (input)="pt.filter($event.target.value, 'matterportListingNumber', 'in')">
				</th>
				<th>
					<p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="sitePriorities" appendTo="body"
						(onChange)="pt.filter($event.value, 'sitePriority', 'in')" styleClass="p-column-filter" placeholder="Filter"
						[showClear]="true" optionLabel="name" optionValue="value">
						<ng-template let-option pTemplate="item">
							<span>{{option.name}}</span>
						</ng-template>
					</p-dropdown>
				</th>
				<th [ngStyle]="{'width': 'auto'}"></th>
			</tr>
		</ng-template>
		<ng-template pTemplate="body" let-property let-editing="editing">
			<tr [pEditableRow]="property" class="property-sticky-column">
				<td 
				pFrozenColumn><a href="/property-edit/{{property.shortTermRentalId}}" target="_blank">
						<i class="pi pi-pencil" aria-hidden="true"
							style="color:blue; font-size:110%; padding-right:20px;"></i>&nbsp;&nbsp;{{property.shortTermRentalId}}
					</a></td>

				<td pFrozenColumn [pEditableColumn]="property.listingStatus" [pEditableColumnField]="'listingStatus'">
				<p-cellEditor>
					<ng-template pTemplate="input">
						<p-dropdown class="w-100" appendTo="body" [options]="listingStatuses" (onChange)="formUpdateProperty(property)" [(ngModel)]="property.listingStatus" optionLabel="name" id="listingStatus"
					optionValue="value"></p-dropdown>
					</ng-template>
					<ng-template pTemplate="output">
						{{ListingStatus[property['listingStatus']] }}
					</ng-template>
				</p-cellEditor>
				</td>

				<td 
				pFrozenColumn ><a href="/property-edit/{{property.shortTermRentalId}}" target="_blank">{{property.propertyCode}}</a>
				</td>
				<td [pEditableColumn]="property.listingType" [pEditableColumnField]="'listingType'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<p-dropdown class="w-100" [options]="listingTypes" (onChange)="formUpdateProperty(property)" [(ngModel)]="property.listingType" optionLabel="name" id="status"
						optionValue="value"></p-dropdown>
						</ng-template>
						<ng-template pTemplate="output">
							{{ListingTypes[property['listingType']] }}
						</ng-template>
					</p-cellEditor>
				</td>
				<td [pEditableColumn]="property.locationId" [pEditableColumnField]="'locationId'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<p-dropdown class="w-100" [options]="locationIds" (onChange)="formUpdateProperty(property)" [(ngModel)]="property.locationId" optionLabel="name" id="status"
						optionValue="value"></p-dropdown>
						</ng-template>
						<ng-template pTemplate="output">
							{{Locations[property['locationId']]}}
						</ng-template>
					</p-cellEditor>
				</td>
				<td [pEditableColumn]="property.propertyName" [pEditableColumnField]="'propertyName'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.propertyName">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.propertyName}}
						</ng-template>
					</p-cellEditor>
				</td>
				<td [pEditableColumn]="property.developmentName" [pEditableColumnField]="'developmentName'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.developmentName">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.developmentName}}
						</ng-template>
					</p-cellEditor>
				<td [pEditableColumn]="property.adrType" [pEditableColumnField]="'adrType'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.adrType">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.adrType}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.adrStreetNumber" [pEditableColumnField]="'adrStreetNumber'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.adrStreetNumber">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.adrStreetNumber}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.adrStreetName" [pEditableColumnField]="'adrStreetName'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.adrStreetName">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.adrStreetName}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.adrUnit" [pEditableColumnField]="'adrUnit'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.adrUnit">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.adrUnit}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.adr2" [pEditableColumnField]="'adr2'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.adr2">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.adr2}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.adrBuildingName" [pEditableColumnField]="'adrBuildingName'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.adrBuildingName">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.adrBuildingName}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.adrComplexName" [pEditableColumnField]="'adrComplexName'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.adrComplexName">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.adrComplexName}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.adrDistrictName" [pEditableColumnField]="'adrDistrictName'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.adrDistrictName">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.adrDistrictName}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.adrCity" [pEditableColumnField]="'adrCity'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.adrCity">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.adrCity}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.adrCounty" [pEditableColumnField]="'adrCounty'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.adrCounty">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.adrCounty}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.adrMetro" [pEditableColumnField]="'adrMetro'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.adrMetro">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.adrMetro}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.adrCountry" [pEditableColumnField]="'adrCountry'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.adrCountry">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.adrCountry}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.adrRegion" [pEditableColumnField]="'adrRegion'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.adrRegion">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.adrRegion}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.adrState" [pEditableColumnField]="'adrState'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.adrState">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.adrState}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.adrPostalCode" [pEditableColumnField]="'adrPostalCode'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.adrPostalCode">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.adrPostalCode}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.adrIsland" [pEditableColumnField]="'adrIsland'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.adrIsland">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.adrIsland}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.adrCrossStreet" [pEditableColumnField]="'adrCrossStreet'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.adrCrossStreet">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.adrCrossStreet}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.adrLongitude" [pEditableColumnField]="'adrLongitude'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.adrLongitude">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.adrLongitude}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.adrLatitude" [pEditableColumnField]="'adrLatitude'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.adrLatitude">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.adrLatitude}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.propertyType" [pEditableColumnField]="'propertyType'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<p-dropdown class="w-100" [options]="propertyTypes" (onChange)="formUpdateProperty(property)" [(ngModel)]="property.propertyType" optionLabel="name" id="status"
						optionValue="value"></p-dropdown>
						</ng-template>
						<ng-template pTemplate="output">
							{{PropertyTypes[property['propertyType']] }}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.propertySubType" [pEditableColumnField]="'propertySubType'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.propertySubType">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.propertySubType}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.yearBuilt" [pEditableColumnField]="'yearBuilt'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.yearBuilt">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.yearBuilt}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.floorOfProperty" [pEditableColumnField]="'floorOfProperty'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.floorOfProperty">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.floorOfProperty}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.floorsInBuilding" [pEditableColumnField]="'floorsInBuilding'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.floorsInBuilding">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.floorsInBuilding}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.sizeInterior" [pEditableColumnField]="'sizeInterior'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.sizeInterior">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.sizeInterior}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.sizeExterior" [pEditableColumnField]="'sizeExterior'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.sizeExterior">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.sizeExterior}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.sizeLot" [pEditableColumnField]="'sizeLot'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.sizeLot">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.sizeLot}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.bedroomNum" [pEditableColumnField]="'bedroomNum'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.bedroomNum">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.bedroomNum}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.sleepsMax" [pEditableColumnField]="'sleepsMax'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.sleepsMax">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.sleepsMax}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.sleepsMaxInBeds" [pEditableColumnField]="'sleepsMaxInBeds'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.sleepsMaxInBeds">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.sleepsMaxInBeds}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.bathroomNum" [pEditableColumnField]="'bathroomNum'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.bathroomNum">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.bathroomNum}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.hotelRoomType" [pEditableColumnField]="'hotelRoomType'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.hotelRoomType">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.hotelRoomType}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.showBookOnline" [pEditableColumnField]="'showBookOnline'">
					<!-- <p-cellEditor>
						<ng-template pTemplate="input">
							<p-dropdown class="w-100" [options]="propertyTypes" (onChange)="formUpdateProperty(property)" [(ngModel)]="property.showBookOnline" optionLabel="name" id="status"
						optionValue="value"></p-dropdown>
						</ng-template>
						<ng-template pTemplate="output">
							{{property.showBookOnline}}
						</ng-template>
					</p-cellEditor> -->
					{{property.showBookOnline}}</td>
				<td [pEditableColumn]="property.showPublicCalendar" [pEditableColumnField]="'showPublicCalendar'">
					<!-- <p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.propertyName">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.showPublicCalendar}}
						</ng-template>
					</p-cellEditor> -->
					{{property.showPublicCalendar}}</td>
				<td [pEditableColumn]="property.minNightlyRate" [pEditableColumnField]="'minNightlyRate'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.minNightlyRate">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.minNightlyRate}}
						</ng-template>
					</p-cellEditor>{{property.minNightlyRate}}</td>
				<td [pEditableColumn]="property.annualRevTargetAmnt" [pEditableColumnField]="'annualRevTargetAmnt'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.annualRevTargetAmnt">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.annualRevTargetAmnt}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.rateBucketAdjusterPct" [pEditableColumnField]="'rateBucketAdjusterPct'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.rateBucketAdjusterPct">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.rateBucketAdjusterPct}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.guestFeeNightly" [pEditableColumnField]="'guestFeeNightly'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.guestFeeNightly">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.guestFeeNightly}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.minLengthOfStay" [pEditableColumnField]="'minLengthOfStay'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.minLengthOfStay">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.minLengthOfStay}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.cleaningFeeDeparture" [pEditableColumnField]="'cleaningFeeDeparture'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.cleaningFeeDeparture">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.cleaningFeeDeparture}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.cleaningFeeInterim" [pEditableColumnField]="'cleaningFeeInterim'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.cleaningFeeInterim">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.cleaningFeeInterim}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.salesTaxRate" [pEditableColumnField]="'salesTaxRate'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.salesTaxRate">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.salesTaxRate}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.roomTaxRate" [pEditableColumnField]="'roomTaxRate'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.roomTaxRate">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.roomTaxRate}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.rULocationId" [pEditableColumnField]="'rULocationId'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.rULocationId">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.rULocationId}}
						</ng-template>
					</p-cellEditor></td>
				<td [pEditableColumn]="property.taxId" [pEditableColumnField]="'taxId'">
					<p-cellEditor>
						<ng-template pTemplate="input">
							<input pInputText type="text" (blur)="formUpdateProperty(property)" [(ngModel)]="property.taxId">
						</ng-template>
						<ng-template pTemplate="output">
							{{property.taxId}}
						</ng-template>
					</p-cellEditor></td>
				<td>{{property.permitId}}</td>
				<td>
					<a href="https://www.vrbo.com/{{property.vrboId}}" target="_blank">
						{{property.vrboId}}
					</a>
				</td>
				<td><a href="https://new.rentalsunited.com/MyProperties/Edit/{{property.ruPropertyId}}" target="_blank">
						{{property.ruPropertyId}}
					</a>
				</td>
				<td>{{property.slPropertyId}}
				</td>
				<td>
					<a href="https://my.matterport.com/models/{{property.matterportId}}" target="_blank">
						{{property.matterportId}}
					</a>
				</td>
				<!-- <td>{{property.sitePriority}}</td> -->
				<td><p-dropdown class="w-100" [options]="sitePriorities" [(ngModel)]="property.sitePriority" optionLabel="name" appendTo="body"
					optionValue="value" (onChange)="formUpdate(property)" placeholder="Select Priority"></p-dropdown>
					</td>
				<td><span style="float:none">
						<a>
							<i class="pi pi-copy" aria-hidden="true" style="color:blue; font-size:110%; padding-right:20px;"
								(click)="onCopyToNewPropertyClick(property)"></i>
						</a>
					</span>
				</td>
			</tr>
		</ng-template>
		<ng-template pTemplate="paginatorCenter"> Showing {{recordTotal < 1 ? 0 : (lazyLoadEvent.first + 1)}} -
				{{recordTotal> 0 ? ((lazyLoadEvent.rows+ lazyLoadEvent.first) <= recordTotal ? (lazyLoadEvent.rows +
					lazyLoadEvent.first) : recordTotal) : 0}} of {{recordTotal ? recordTotal : 0}} </ng-template>
	</p-table>
</div>
